export default "__VITE_ASSET__B7iZTIEg__"